import { TWorkflowEventDescriptor } from '@commenda/types';
import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';
import { WORKFLOW_EVENT_BASE_URL } from './helpers';

export type TWorkflowAppDescriptor = {
  id: string;
  name: string;
  erpProviders?: string[];
  events: TWorkflowEventDescriptor[];
};

export type TEventCatalogResponse = {
  apps: TWorkflowAppDescriptor[];
};

export const useEventCatalog = () => {
  const { data, error, isLoading, mutate } = useSWR<TEventCatalogResponse>(
    WORKFLOW_EVENT_BASE_URL,
    SWRFetcher({ method: 'GET' })
  );

  return { data, error, isLoading, mutate };
};
